import { render, staticRenderFns } from "./BetgameEditPublic.vue?vue&type=template&id=fde14930&scoped=true"
import script from "./BetgameEditPublic.vue?vue&type=script&lang=js"
export * from "./BetgameEditPublic.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditPublic.vue?vue&type=style&index=0&id=fde14930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde14930",
  null
  
)

export default component.exports